import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';
import { displayableCashback, renderPluralConditional } from '../../services/partner/utils';

import SvgComponent from '../SvgComponent';

import './DiscountListComponent.scss';

const Discount = ({ discount, textRefund, showArrow, isQwertys }) => {
    const renderCashback = cashback => (
        <span className="value">
            {`${displayableCashback(cashback.percent, cashback.fixed)} ${renderPluralConditional(
                textRefund,
                () => cashback && (cashback.fixed > 1 || cashback.percent > 1)
            )}`}
        </span>
    );

    const renderWording = () => {
        if (discount.label) {
            return ` ${convertHtmlToReactDomWithParams(discount.label)}`;
        }
    };

    return (
        !isEmpty(discount) && (
            <li className="discount">
                {showArrow && (
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        width="6"
                        height="10"
                        aria-hidden="true"
                        focusable="false"
                    />
                )}
                {isQwertys ? (
                    convertHtmlToReactDomWithParams(discount.label)
                ) : (
                    <React.Fragment>
                        {renderCashback(discount.cashback)}
                        {renderWording()}
                    </React.Fragment>
                )}
            </li>
        )
    );
};

const mapStoreToProps = state => ({ REFUND: state.i18n.feature.partenaire.rembourse });

export const DiscountListComponent = connect(mapStoreToProps)(
    ({ discounts, REFUND, showArrow = false, isQwertys = false }) => {
        if (discounts && discounts.length > 0) {
            return (
                <ul className="discounts">
                    {discounts.map(discount => (
                        <Discount
                            key={discount.id}
                            discount={discount}
                            textRefund={REFUND}
                            showArrow={showArrow}
                            isQwertys={isQwertys}
                        />
                    ))}
                </ul>
            );
        }
        return null;
    }
);



// WEBPACK FOOTER //
// ./src/components/discount/DiscountListComponent.js